<template>
  <WdsAvatarLabel :path="avatarPath" truncated sm>
    <template #subText>
      <WdsText primary>
        {{ getWorkerDisplayName(column.worker.name) }}
      </WdsText>
    </template>
  </WdsAvatarLabel>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsAvatarLabel, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { getAvatarPath } from '@/utils/avatar'
import { getWorkerDisplayName } from '@/utils/worker'

const HireWorkerColumnFragment = graphql(`
  fragment HireWorkerColumn on Hire {
    worker {
      id
      name
      avatar
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof HireWorkerColumnFragment> }>()
const column = computed(() => useFragment(HireWorkerColumnFragment, props.row))

const avatarPath = computed(() => getAvatarPath(column.value.worker.avatar, column.value.worker.id))
</script>
